import React from "react";
import "../assets/styles/footer.css";

// Import social media icons as image paths
import facebookIcon from "../assets/images/facebook-logo-white.png";
import twitterIcon from "../assets/images/x-logo-white.png";
import threadsIcon from "../assets/images/threads-logo-white.png";
import instagramIcon from "../assets/images/instagram-logo-white.png";

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <p>&copy; 2025 SeeingMoney. All Rights Reserved.</p>

        <div className="social-links">
          <a href="https://www.facebook.com/share/1BqmW3Du4a/?mibextid=wwXlfr" target="_blank" rel="noopener noreferrer">
            <img src={facebookIcon} alt="Facebook" className="social-icon" />
          </a>
          <a href="https://x.com/seeing_money?s=21" target="_blank" rel="noopener noreferrer">
            <img src={twitterIcon} alt="Twitter" className="social-icon" />
          </a>
          <a href="https://www.threads.net/@Seeing.Money" target="_blank" rel="noopener noreferrer">
            <img src={threadsIcon} alt="Threads" className="social-icon" />
          </a>
          <a href="https://www.instagram.com/Seeing.Money/" target="_blank" rel="noopener noreferrer">
            <img src={instagramIcon} alt="Instagram" className="social-icon" />
          </a>
        </div>

      </div>
    </footer>
  );
};

export default Footer;